// Copyright 2026. WebPros International GmbH. All rights reserved.

export const RESET_STATE = 'RESET_STATE';
